import { useApp, useBehavior, useList, useTriggerAction } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TCarouselData } from '../../types/data';
import { CarouselView } from './CarouselView';

export const CarouselWidget = ({ widget }: TWidgetProps<TCarouselData>) => {
    const { isHidden } = useBehavior(widget);
    const { setModal, setPopup, setBottomSheet } = useApp();
    const { triggerActionsByType } = useTriggerAction(widget);
    const { handleClick } = useList(widget, { triggerActionsByType, setModal, setPopup, setBottomSheet });

    return (
        <CarouselView
            widget={widget}
            uid={widget.uid}
            items={widget.data?.items}
            margin={widget.options?.margin}
            styleName={widget.options?.style}
            isHide={isHidden}
            onItemClick={handleClick}
        />
    );
};
